export const SpinnerFloatingComponent = {
  templateUrl: 'components/Loaders/spinner-floating/spinner-floating.html',
};
